import { call, put, takeLatest } from 'redux-saga/effects';

import {
  LOADING_DATA_START,
  LOADING_DATA_FINISHED,
} from '../reducers/loading.reducer';
import { handleError } from './helper';
import {
  EVENTS_FETCH,
  EVENTS_FETCH_SUCCESS,
  EVENTS_FETCH_FAILURE,
} from '../reducers/events.reducer';
import { eventsApi } from '../services';

function* fetchEventsRequest({ payload: { id } }) {
  try {
    yield put({ type: LOADING_DATA_START });
    const { data } = yield call(eventsApi.fetchEvents, { id });
    yield put({ type: EVENTS_FETCH_SUCCESS, payload: data });
  } catch (error) {
    const message = yield* handleError(error);
    yield put({ type: EVENTS_FETCH_FAILURE, payload: message });
  }
  yield put({ type: LOADING_DATA_FINISHED });
}

export function* fetchEvents() {
  yield takeLatest(EVENTS_FETCH, fetchEventsRequest);
}



// WEBPACK FOOTER //
// ./src/sagas/events.saga.js